
import * as React from "react";
import { Switch } from "./switch";

interface SwitchWithLabelProps {
  label: string;
  checked: boolean;
  disabled?:boolean;
  onCheckedChange: (checked: boolean) => void;
  labelPosition?: "left" | "right";
  labelColor?: string;
  activeColor?: string;
  inactiveColor?: string;
  className?: string;
  count?: number;
  countColor?: string;
}

const SwitchWithLabel: React.FC<SwitchWithLabelProps> = ({
  label,
  checked,
  disabled =false,
  onCheckedChange,
  labelPosition = "right",
  labelColor,
  activeColor = "bg-bytesplash-blue",
  inactiveColor = "bg-gray-200",
  className = "",
  count,
  countColor
}) => {
  // Ensure we have valid inputs
  const safeLabel = label || "Toggle";
  const safeChecked = !!checked; // Convert to boolean
  
  // Safely determine countColor with null checks
  const safeCountColor = countColor || 
    (typeof checked !== 'undefined' && checked 
      ? "bg-bytesplash-blue text-white" 
      : "bg-red-100 text-red-800");
  
  // Safely determine the active/inactive classes
  const safeActiveColor = activeColor || "bg-bytesplash-blue";
  const safeInactiveColor = inactiveColor || "bg-gray-200";
  
  return (
    <div
      className={`flex items-center ${
        labelPosition === "right" ? "space-x-2" : "flex-row-reverse justify-end space-x-reverse space-x-2"
      } ${className}`}
    >
      {labelPosition === "left" && (
        <span className={`text-sm font-medium ${labelColor || ""}`}>{safeLabel}</span>
      )}
      <Switch
        checked={safeChecked}
        disabled={disabled}
        onCheckedChange={onCheckedChange}
        className={safeChecked ? safeActiveColor : safeInactiveColor}
      />
      {labelPosition === "right" && (
        <span className={`text-sm font-medium ${labelColor || ""}`}>{safeLabel}</span>
      )}
      
      {typeof count !== 'undefined' && (
        <div className={`rounded-full ${safeCountColor} py-1 px-4 text-sm font-semibold ml-2`}>
          {count}
        </div>
      )}
    </div>
  );
};

export { SwitchWithLabel };
